import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { linkStyles } from '../Link/Link';

const InternalLink = styled(Link)<{ $disabled?: boolean }>`
  ${linkStyles}
  ${({ theme, $disabled }) =>
    $disabled && `color: ${theme.palette.content.disabled};`}
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

export default InternalLink;
